import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "x-api-key": `${process.env.REACT_APP_BACKEND_TOKEN}`,
    "Content-Type": "application/json",
  },
});

export default api;

export const getdeliverytime = (orderId) => {
  return api.get(`/getOrdersETA/${orderId}`);
};

export const getOrderDetails = (orderID) => {
  return api.post("/order/details", { orderId: orderID });
};

export const getRobotStatus = (robotId) => {
  return api.post("/robot/v1/getRobotStatus", { robotId });
};

export const getGeofenceByFleetId = (fleetId) => {
  return api.post("/robot/v2/getFleetGeofence", { fleetId });
};

export const getFleetConfig = (orderId) => {
  return api.get(`/fleet/config?orderId=${orderId}`);
};

export const getFleetConfigByFleetId = (fleetId) => {
  return api.get(`/fleet/config?fleetId=${fleetId}`);
};

export const getActiveMission = (robotId) => {
  return api.post("/robot/activemission", { robotId });
};

export const submitFeedback = (orderId, feedbackData) => {
  return api.post("/order/feedback", {
    orderId,
    rating: feedbackData.rating,
    comment: feedbackData.comment,
    customerName: feedbackData.customerName,
    customerPhone: feedbackData.customerPhone,
  });
};

export const getFeedback = (orderId) => {
  return api.get(`/order/feedback/${orderId}`);
};

export const cancelOrder = (fleetId, orderId) => {
  return api.post("/order/cancel", {
    fleetId,
    orderId,
    message: "order removed",
    canceledByCustomer: true,
  });
};

/**
 * Submit feedback to Google Forms using formResponse endpoint
 * @param {string} orderId - Order ID
 * @param {object} feedbackData - Feedback data containing rating, comment, customerName, customerPhone, deliveryLocation
 * @returns {Promise} - Promise that resolves when submission is sent (note: with no-cors mode, we can't verify success)
 */
export const submitToGoogleForm = async (orderId, feedbackData) => {
  try {
    // Google Form ID extracted from the URL
    const FORM_ID = '1FAIpQLSepyxurm5h6addCOe72LmPoyqlxccCRTCtesUcBzAlKrI1fcA';
    
    // Entry ID mappings from the Google Form URL
    const ENTRY_IDS = {
      orderId: 'entry.163918187',
      location: 'entry.1717235017',
      name: 'entry.762060752',
      phone: 'entry.1089182066',
      rating: 'entry.562696632',
      comment: 'entry.221290761',
    };

    // Build formResponse URL
    const formResponseUrl = `https://docs.google.com/forms/d/e/${FORM_ID}/formResponse`;

    // Create URL-encoded form data
    const formData = new URLSearchParams();
    formData.append(ENTRY_IDS.orderId, orderId || '');
    formData.append(ENTRY_IDS.location, feedbackData.deliveryLocation || '');
    formData.append(ENTRY_IDS.name, feedbackData.customerName || '');
    formData.append(ENTRY_IDS.phone, feedbackData.customerPhone || '');
    formData.append(ENTRY_IDS.rating, feedbackData.rating?.toString() || '');
    formData.append(ENTRY_IDS.comment, feedbackData.comment || '');

    // Submit to Google Forms
    // Note: Using 'no-cors' mode because Google Forms doesn't allow CORS
    // This means we can't read the response, but the submission still works
    const response = await fetch(formResponseUrl, {
      method: 'POST',
      mode: 'no-cors', // Required for Google Forms submission
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
    });

    // With no-cors mode, response will be opaque, so we can't verify success
    // But the submission should work. Return a resolved promise to indicate we sent it.
    return Promise.resolve({ success: true });
  } catch (err) {
    console.error('Google Form submission error:', err);
    throw err;
  }
};